import axios from 'axios';
import { IModelGSystemParameter } from '@/shared/model/model-g-system-parameter.model';

const baseApiUrl = 'api/model-g-system-parameters';

export default class ModelGSystemParameterService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IModelGSystemParameter): Promise<IModelGSystemParameter> {
    return new Promise<IModelGSystemParameter>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public reset(parameterId: number): Promise<IModelGSystemParameter> {
    return new Promise<IModelGSystemParameter>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/reset/${parameterId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
